// extracted by mini-css-extract-plugin
module.exports = {"flagTag":"flagTag--HTHiZ"};